import { render, staticRenderFns } from "./pvData.vue?vue&type=template&id=5037061d&scoped=true&"
import script from "./pvData.vue?vue&type=script&lang=js&"
export * from "./pvData.vue?vue&type=script&lang=js&"
import style0 from "./pvData.vue?vue&type=style&index=0&id=5037061d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037061d",
  null
  
)

component.options.__file = "pvData.vue"
export default component.exports